import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.scss';

const Icon = ({ type }) => (
  <span className="app-icon-wrapper">
    <span className={`app-icon icon-sm ${styles[type]}`} />
  </span>
);

Icon.propTypes = {
  type: PropTypes.oneOf(['info', 'remove']).isRequired
};

export default Icon;
